module.exports = __webpack_public_path__ + "static/media/camera.56df192a.png";